import { logEvent } from "firebase/analytics";
import { analytics } from "../config/firebase";

export type RelayEvent =
  | "banana_toss_started"
  | "banana_root_created"
  | "banana_received_view"
  | "banana_unwrap_started"
  | "banana_unwrap_completed"
  | "banana_reaction_sent"
  | "relay_started"
  | "relay_intent_selected"
  | "relay_child_created"
  | "relay_share_opened"
  | "your_bananas_viewed";

export const logRelayEvent = (event: RelayEvent, parameters: Record<string, unknown> = {}) => {
  if (!analytics) return;
  logEvent(analytics, event, parameters);
};

